import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretDownSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 6.03546L8 10.0355L4 6.03546", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretDownSmall);
const Memo = memo(ForwardRef);
export default Memo;
